import React from "react";
import { useNavigate } from "react-router-dom";
import { IoBagHandleOutline } from "react-icons/io5";
import AdOptionsMenu from "./AdOptionsMenu";

// Destination -> buyer route. "live" is omitted on purpose: the auction only returns the
// LiveStream row id, while the live pages (/stream/:streamId, /joinlive/:streamId) are keyed by
// the string stream_id, so there is no route to send the viewer to yet.
export function sponsoredAdPath(ad) {
  if (ad.product) return `/ProductView/${ad.product.id}`;
  if (ad.destination_type === "profile") return `/myprofile/${ad.destination_id}`;
  return null;
}

const adImage = (ad) =>
  ad.thumbnail ||
  ad.creative_media?.find((media) => media.media_type === "image")?.url ||
  ad.product?.product_media?.[0]?.url ||
  "/image/shoeimg.png";

// Sidebar "Ad" card from the home-feed design. Render only ads returned by useSponsoredAds
// (i.e. whose impression is already reserved); onClick should record the click event.
export default function SponsoredAdCard({ ad, onClick, onHidden }) {
  const navigate = useNavigate();
  const path = sponsoredAdPath(ad);
  const product = ad.product;
  const currency = product?.seller?.currency_symbol || "$";
  const price = Number(product?.discount_price || product?.product_price || 0);
  const originalPrice = Number(product?.product_price || 0);

  const handleClick = () => {
    onClick?.(ad);
    if (path) navigate(path);
  };

  return (
    <div
      className={`bg-[#FEFDEB] border border-gray-200 rounded-2xl p-3 mb-4 ${path ? "cursor-pointer" : ""}`}
      onClick={handleClick}
    >
      <div className="relative bg-white rounded-xl overflow-hidden">
        <span className="absolute top-2 right-2 bg-[#F97316] text-white text-[10px] font-bold px-2 py-0.5 rounded-md">
          Ad
        </span>
        <AdOptionsMenu ad={ad} onHideAd={onHidden} />
        <img src={adImage(ad)} alt={ad.headline || product?.product_name || ""} className="w-full h-36 object-contain" />
      </div>

      {product ? (
        <div className="mt-2 space-y-1">
          <h4 className="text-[13px] font-bold line-clamp-2 uppercase">{product.product_name}</h4>
          {originalPrice > price && (
            <p className="text-xs font-semibold line-through text-gray-400">
              {currency} {originalPrice.toFixed(2)}
            </p>
          )}
          <div className="flex justify-between items-center">
            <p className="text-[15px] font-bold text-[#095228]">
              {currency} {price.toFixed(2)}
            </p>
            <button
              type="button"
              className="flex gap-1 items-center bg-[#161F28] text-white rounded-xl text-[10px] px-3 py-2"
            >
              <IoBagHandleOutline className="text-[14px]" />
              <span>BUY NOW</span>
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-2 space-y-1">
          <h4 className="text-[13px] font-bold line-clamp-1">{ad.headline}</h4>
          {ad.body_text && <p className="text-xs text-gray-600 line-clamp-2">{ad.body_text}</p>}
        </div>
      )}
    </div>
  );
}
